import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AtsNotificationService } from '@ats/notifications';
import { Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { CmReloadConfirmationComponent } from '../components/cm-reload-confirmation/cm-reload-confirmation.component';

@Injectable()
export class CmReloadService {
	readonly realoadSubscription: Subscription;

	constructor(private readonly dialog: MatDialog, private readonly notifications: AtsNotificationService) {
		this.realoadSubscription = this.notifications.reload$
			.pipe(
				switchMap(() =>
					this.dialog
						.open(CmReloadConfirmationComponent, {
							disableClose: true,
						})
						.afterClosed()
				)
			)
			.subscribe(() => window.location.reload());
	}
}
